import * as React from "react";
import { firebase , db} from "../firebase";
import { AuthUserContext } from "./AuthUserContext";

interface InterfaceProps {
  authUser?: any;
}

interface InterfaceState {
  authUser?: any;
}

export const withAuthentication = (Component: any) => {
  class WithAuthentication extends React.Component<InterfaceProps, InterfaceState> {
    constructor(props: any) {
      super(props);

      this.state = {
        authUser: null
      };
    }

    public componentDidMount() {
      firebase.auth.onAuthStateChanged(authUser => {
        if (authUser) {
        db.doGetUserById(authUser.uid).then(snapshot => {
          const user =snapshot.val();
          user && user.isAdmin
            ? this.setState(() => ({ authUser }))
            : this.setState(() => ({ authUser: null }));
          });
        }
        else {
          this.setState(() => ({ authUser: null }));
        }
    })
    }

    public render() {
      const { authUser } = this.state;
      return (
        <AuthUserContext.Provider value={authUser}>
          <Component />
        </AuthUserContext.Provider>
      );
    }
  }
  return WithAuthentication;
};



// WEBPACK FOOTER //
// ./src/firebase/withAuthentication.tsx